import './ErrorScreen.css';

function ErrorScreen({ error }) {
    return (
        <div className="error-container">
            <div className="error-box">
                <h1 className="error-title">Error {error}</h1>
            </div>
        </div>
    );
}

export default ErrorScreen;
